import { render, staticRenderFns } from "./leaderboard_group.vue?vue&type=template&id=490a1164&"
import script from "./leaderboard_group.vue?vue&type=script&lang=js&"
export * from "./leaderboard_group.vue?vue&type=script&lang=js&"
import style0 from "./leaderboard_group.vue?vue&type=style&index=0&id=490a1164&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports